import { INotificationsResponse } from "./INotificationsResponse";

export const saveNotifications = (payload: INotificationsResponse) => ({
  type: "SAVE_NOTIFICATIONS",
  payload,
});
